import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from '@mui/x-data-grid'
import moment from 'moment-timezone'
import { loadStateFromLocalStorage } from '../../redux/utilsLocalStorage'

const overridesWeirdResizing = {
  '& .MuiDataGrid-main': {
    width: 0,
    minWidth: '100%',
  },
  '& .MuiDataGrid-row:hover': {
    cursor: 'pointer',
  },
  '& .MuiDataGrid-columnHeaders': {
    minHeight: '40px !important',
    maxHeight: '40px !important',
    height: '40px !important',
  },
  '& .MuiDataGrid-footerContainer': {
    minHeight: '40px !important',
    maxHeight: '40px !important',
    height: '40px !important',
  },
}

const CustomToolbar = ({ user }) => {
  return (
    <GridToolbarContainer>
      <GridToolbarFilterButton />
      <GridToolbarColumnsButton />
      {/* <GridToolbarDensitySelector /> */}
      <GridToolbarExport
        csvOptions={{
          delimiter: ';',
          fileName: `Logs_${user.name}`,
          utf8WithBom: true,
        }}
        printOptions={{ disableToolbarButton: true }}
      />
    </GridToolbarContainer>
  )
}

const UserLogsTable = props => {
  const { userLogs, user } = props
  const userTimezone = loadStateFromLocalStorage('timezone') || 'Etc/UTC'

  const renderDateTime = params => {
    // Only for specific date fields
    if (
      ['timestamp', 'start_date', 'end_date'].includes(params.field) &&
      params.value &&
      !isNaN(Number(params.value))
    ) {
      return moment
        .unix(Number(params.value))
        .tz(userTimezone)
        .format('YYYY-MM-DD HH:mm')
    }
    return ''
  }

  const columns = [
    {
      field: 'timestamp',
      headerName: 'TIMESTAMP',
      flex: 1.3,
      type: 'number',
      headerClassName: 'super-app-theme--header',
      valueFormatter: renderDateTime,
    },
    {
      field: 'url',
      headerName: 'URL',
      flex: 0.8,
      headerClassName: 'super-app-theme--header',
    },

    {
      field: 'setup_name',
      headerName: 'SETUP',
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'plant',
      headerName: 'PLANT',
      flex: 1.2,
      headerClassName: 'super-app-theme--header',
    },

    {
      field: 'forecast',
      headerName: 'FORECAST',
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'forecast_type',
      headerName: 'TYPE',
      flex: 0.6,
      headerClassName: 'super-app-theme--header',
    },

    {
      field: 'start_date',
      headerName: 'START DATE',
      flex: 1.2,
      type: 'number',
      headerClassName: 'super-app-theme--header',
      valueFormatter: renderDateTime,
    },
    {
      field: 'end_date',
      headerName: 'END DATE',
      flex: 1.2,
      type: 'number',
      headerClassName: 'super-app-theme--header',
      valueFormatter: renderDateTime,
    },
    {
      field: 'issue_time',
      headerName: 'ISSUE TIME',
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'percentiles',
      headerName: 'PERCENTILES',
      flex: 1.2,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'aggregation_level',
      headerName: 'AGGR LEVEL',
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'aggregation_value',
      headerName: 'AGGR VALUE',
      flex: 1.4,
      valueGetter: params => {
        const av = params.row.aggregation_value
        if (!av) return ''
        return `Country: ${av.Country}, TSO: ${av.TSO}, Technology: ${av.Technology}`
      },
    },
  ]

  return (
    userLogs.length > 0 && (
      <DataGrid
        rows={userLogs}
        rowHeight={20}
        headerHeight={40}
        columns={columns}
        getRowId={row => row.id}
        sx={overridesWeirdResizing}
        disableColumnMenu
        initialState={{
          sorting: {
            sortModel: [{ field: 'timestamp', sort: 'desc' }],
          },
        }}
        slots={{
          toolbar: () => <CustomToolbar user={user} />,
        }}
      />
    )
  )
}

export default UserLogsTable
